import React from 'react';

const createBubbles = () => {
  const bubbles = [];
  for (let i = 0; i < 20; i++) {
    const size = Math.random() * 15 + 5;
    bubbles.push({
      id: i,
      size,
      left: `${Math.random() * 100}%`,
      delay: Math.random() * 4,
      duration: 3 + Math.random() * 2
    });
  }
  return bubbles;
};

const BeerProgress = ({ totalKm, targetKm, countdown }) => (
  <div className="progress-container">
    <div className="beer-bottle">
      <div
        className="beer-fill"
        style={{ height: `${Math.min((totalKm / targetKm) * 100, 100)}%` }}
      >
        <div className="beer-foam"></div>
        <div className="beer-bubbles">
          {createBubbles().map(bubble => (
            <div
              key={bubble.id}
              className="bubble"
              style={{
                width: `${bubble.size}px`,
                height: `${bubble.size}px`,
                left: bubble.left,
                animationDelay: `${bubble.delay}s`,
                animationDuration: `${bubble.duration}s`
              }}
            />
          ))}
        </div>
      </div>
      <div className="beer-label">
        {Math.round((totalKm / targetKm) * 100)}%
      </div>
    </div>
    <h3 style={{ marginTop: '20px', textAlign: 'center' }}>
      {totalKm.toFixed(1)} von {targetKm} km
    </h3>
    <div style={{ textAlign: 'center', color: '#666' }}>
      {totalKm >= targetKm ? (
        <span style={{ fontSize: '1.2em', color: 'var(--secondary)' }}>
          🍺 Ziel erreicht! 🍺
        </span>
      ) : (
        <>
          <div>Noch {(targetKm - totalKm).toFixed(1)} km bis zum Bier!</div>
          <div className="countdown">Verbleibende Zeit: {countdown}</div>
        </>
      )}
    </div>
  </div>
);

export default BeerProgress;
